import { Button } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

export const RelationAddExistingUser = () => {
  const { t } = useTranslation("common");
  const { id } = useParams();

  return (
    <div className={"me-3"}>
      <Link to={`/relations/edit/${id}/employees/add-existing`}>
        <Button size="sm" className={"responsive-button"}>
          {t("Add existing user")}
        </Button>
      </Link>
    </div>
  );
};
